<template>
  <div>
    <v-btn @click="fetch">GO!</v-btn>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  methods: {
    fetch() {
      axios
        .get(
          'https://live.midttrafik.dk/getbuses.php?lat=56.161389839321856&lon=10.182496333113527&radius=695.8887080592295'
        )
        .then(response => {
          console.log('+++++SUCCESS++++++');
          console.log(response);
        })
        .catch(() => {
          console.log('-----ERROR----');
        });
    }
  }
};
</script>

<style scoped>
</style>